<!------------------------------

      Page Actions

------------------------------->
<ng-container *sbPageAction>
  @if (!isInModalContext) {
    <button
      *ngPermissions="permissionService.Permission.planning_create"
      sb-button-primary
      type="button"
      [color]="'green'"
      icon="plus"
      [sbTooltip]="'lang.planningsList.newPlanning' | translate"
      [iconButton]="true"
      [queryParams]="{returnTo: util.getPageLink()}"
      [sbRouterLink]="util.RoutingID.planningCreate">
    </button>
    <button
      type="button"
      sb-button-primary
      icon="refresh"
      [iconButton]="true"
      [color]="'blue'"
      (click)="requestDebounced()"
      [disabled]="loading()"
      [loading]="loading()"
      sbTooltip="{{ 'lang.globals.refresh' | translate }}" container="body"
      placement="top">
    </button>

    <button
      type="button"
      sb-button-primary
      icon="plannings"
      [iconButton]="true"
      [color]="'blue'"
      [disabled]="loading()"
      [sbRouterLink]="util.RoutingID.planningView"
      [loading]="loading()"
      sbTooltip="{{ 'lang.globals.currentPlan' | translate }}" container="body"
      placement="top">
    </button>

  }
</ng-container>
<!------------------------------

    Table wrapper

------------------------------->

@let ordering = orderOption();
<sb-table-wrapper-new
  headline="{{'lang.planningsList.headline' | translate}}"
  [itemsData]="planningData"
  (paginationChange)="requestDebounced($event)"
  [loading]="loading()" [itemName]="'plannings'" [isInModalContext]="isInModalContext">

  <!------------------------------

      Filter Panel

  ------------------------------->
  <div filter-panel class="tw-bg-[#F8F9FC] dark:tw-bg-sbGray-930 tw-rounded-l-xl">
    <sb-filter-panel
      #FilterPanelRef
      (filterChange)="applyFiltering($event)"
      [headerClasses]="'tw-bg-sbGray-50 dark:tw-bg-sbGray-930 tw-border-solid tw-border-0 tw-z-40 tw-border-b tw-border-sbGray-500 dark:tw-border-sbGray-50 tw-h-[60px] tw-rounded-tl-xl'"
      [config]="filterConfig"
      filterID="search"
    >
      <sb-filter-section *ngPermissions="permissionService.Permission.company_list" title="{{'lang.globals.companies' | translate}}"
                         icon="company">
        <sb-filter-dto-list-select filterID="companies" [isSingleSelect]="true" [endpoint]="api.shared_Company_retrieveAll.bind(api)"
                                   [defaultValues]="selectedCompany? [selectedCompany] : []">
        </sb-filter-dto-list-select>
      </sb-filter-section>

      <ng-template #orderSection>
        <sb-filter-section
          [alwaysExpanded]="true" [hideValueIndicatorIfDefaultSelected]="true" [showTag]="false"
          title="{{'lang.globals.order' | translate}}" icon="sort">
          <sb-filter-order
            [allOrderOptions]="allOrderOptions|omit: 'direction'"
            [selectedOrderOption]="orderOption()"
          >
          </sb-filter-order>
        </sb-filter-section>
      </ng-template>
    </sb-filter-panel>
  </div>
  <!------------------------------

        Table Header

  ------------------------------->
  <ng-template #thead>
    <tr>
      <th class="table--sortable"
          (click)="setToOrderAndRefresh(ds_cm_Planning_retrieveAll_order.NAME)"
          [ngClass]="{'table--sorted': ordering?.value===ds_cm_Planning_retrieveAll_order.NAME}">
        {{ 'lang.planningsList.name' | translate }}
        @if (ordering.value === ds_cm_Planning_retrieveAll_order.NAME) {
          @if (ordering.direction === 'desc') {
            <sb-icon icon="sortDownFilled" class="icon-in-btn"></sb-icon>
          } @else {
            <sb-icon icon="sortUpFilled" class="icon-in-btn"></sb-icon>
          }
        } @else {
          <sb-icon
            icon="sort" class="icon-in-btn"></sb-icon>
        }
      </th>
      <th class="table--sortable"
          (click)="setToOrderAndRefresh(ds_cm_Planning_retrieveAll_order.CUSTOMER)"
          [ngClass]="{'table--sorted': ordering?.value===ds_cm_Planning_retrieveAll_order.CUSTOMER}">
        {{ 'lang.planningsList.customer' | translate }}
        @if (ordering.value === ds_cm_Planning_retrieveAll_order.CUSTOMER) {
          @if (ordering.direction === 'desc') {
            <sb-icon icon="sortDownFilled" class="icon-in-btn"></sb-icon>
          } @else {
            <sb-icon icon="sortUpFilled" class="icon-in-btn"></sb-icon>
          }
        } @else {
          <sb-icon
            icon="sort" class="icon-in-btn"></sb-icon>
        }
      </th>
      <th class="table--sortable"
          (click)="setToOrderAndRefresh(ds_cm_Planning_retrieveAll_order.MODIFIED_AT)"
          [ngClass]="{'table--sorted': ordering?.value===ds_cm_Planning_retrieveAll_order.MODIFIED_AT}">
        {{ 'lang.globals.modifiedAt' | translate }}
        @if (ordering.value === ds_cm_Planning_retrieveAll_order.MODIFIED_AT) {
          @if (ordering.direction === 'desc') {
            <sb-icon icon="sortDownFilled" class="icon-in-btn"></sb-icon>
          } @else {
            <sb-icon icon="sortUpFilled" class="icon-in-btn"></sb-icon>
          }
        } @else {
          <sb-icon
            icon="sort" class="icon-in-btn"></sb-icon>
        }
      </th>
      <th class="table--sortable"
          (click)="setToOrderAndRefresh(ds_cm_Planning_retrieveAll_order.CREATED_AT)"
          [ngClass]="{'table--sorted': ordering?.value===ds_cm_Planning_retrieveAll_order.CREATED_AT}">
        {{ 'lang.globals.createdAt' | translate }}
        @if (ordering.value === ds_cm_Planning_retrieveAll_order.CREATED_AT) {
          @if (ordering.direction === 'desc') {
            <sb-icon icon="sortDownFilled" class="icon-in-btn"></sb-icon>
          } @else {
            <sb-icon icon="sortUpFilled" class="icon-in-btn"></sb-icon>
          }
        } @else {
          <sb-icon
            icon="sort" class="icon-in-btn"></sb-icon>
        }
      </th>
      <th class="sticky-col last-col">{{ 'lang.globals.action' | translate }}</th>
    </tr>
  </ng-template> <!------------------------------

        Card Table Header

  ------------------------------->
  <ng-template #tCardHead>
    <tr>
      <th class="table--sortable"
          (click)="setToOrderAndRefresh(ds_cm_Planning_retrieveAll_order.NAME)"
          [ngClass]="{'table--sorted': ordering?.value===ds_cm_Planning_retrieveAll_order.NAME}">
        {{ 'lang.planningsList.name' | translate }}
        @if (ordering.value === ds_cm_Planning_retrieveAll_order.NAME) {
          @if (ordering.direction === 'desc') {
            <sb-icon icon="sortDownFilled" class="icon-in-btn"></sb-icon>
          } @else {
            <sb-icon icon="sortUpFilled" class="icon-in-btn"></sb-icon>
          }
        } @else {
          <sb-icon
            icon="sort" class="icon-in-btn"></sb-icon>
        }
      </th>
      <th class="table--sortable"
          (click)="setToOrderAndRefresh(ds_cm_Planning_retrieveAll_order.CUSTOMER)"
          [ngClass]="{'table--sorted': ordering?.value===ds_cm_Planning_retrieveAll_order.CUSTOMER}">
        {{ 'lang.planningsList.customer' | translate }}
        @if (ordering.value === ds_cm_Planning_retrieveAll_order.CUSTOMER) {
          @if (ordering.direction === 'desc') {
            <sb-icon icon="sortDownFilled" class="icon-in-btn"></sb-icon>
          } @else {
            <sb-icon icon="sortUpFilled" class="icon-in-btn"></sb-icon>
          }
        } @else {
          <sb-icon
            icon="sort" class="icon-in-btn"></sb-icon>
        }
      </th>
      <th class="table--sortable"
          (click)="setToOrderAndRefresh(ds_cm_Planning_retrieveAll_order.MODIFIED_AT)"
          [ngClass]="{'table--sorted': ordering?.value===ds_cm_Planning_retrieveAll_order.MODIFIED_AT}">
        {{ 'lang.globals.modifiedAt' | translate }}
        @if (ordering.value === ds_cm_Planning_retrieveAll_order.MODIFIED_AT) {
          @if (ordering.direction === 'desc') {
            <sb-icon icon="sortDownFilled" class="icon-in-btn"></sb-icon>
          } @else {
            <sb-icon icon="sortUpFilled" class="icon-in-btn"></sb-icon>
          }
        } @else {
          <sb-icon
            icon="sort" class="icon-in-btn"></sb-icon>
        }
      </th>
      <th class="table--sortable"
          (click)="setToOrderAndRefresh(ds_cm_Planning_retrieveAll_order.CREATED_AT)"
          [ngClass]="{'table--sorted': ordering?.value===ds_cm_Planning_retrieveAll_order.CREATED_AT}">
        {{ 'lang.globals.createdAt' | translate }}
        @if (ordering.value === ds_cm_Planning_retrieveAll_order.CREATED_AT) {
          @if (ordering.direction === 'desc') {
            <sb-icon icon="sortDownFilled" class="icon-in-btn"></sb-icon>
          } @else {
            <sb-icon icon="sortUpFilled" class="icon-in-btn"></sb-icon>
          }
        } @else {
          <sb-icon
            icon="sort" class="icon-in-btn"></sb-icon>
        }
      </th>
      <th class="!tw-w-auto"><!-- empty header for minimal header with on the others --></th>
    </tr>
  </ng-template>
  <!------------------------------

      Table Body

------------------------------->
  <ng-template #tbody let-planning>
    <tr [ngClass]="{'active' : planning?.submission}">
      <td>
        <sb-comp-name-wrapper>
          <sb-comp-link
            firstLine
            [title]="planning.name |truncate: 60"
            [tooltip]="'lang.globals.openDetails' | translate"
            [link]="util.RoutingID.planning" [pathParams]="[{id: 'planningID', value: planning?.id}]">
          </sb-comp-link>
          <span secondLine [innerHTML]="planning.description | truncate: 80"></span>
          <sb-tags thirdLine *ngPermissions="[permissionService.Permission.tag_list]" [tags]="planning.tags"
                   [dtoType]="tagService.TaggableDTO.Planning" [dtoId]="planning.id"></sb-tags>
        </sb-comp-name-wrapper>
      </td>
      <td>
        <span [innerHTML]="planning.forCustomer?.name | truncate : 23"></span>
      </td>
      <td>
        <sb-comp-display-modified [data]="planning" [hideTooltip]="true"></sb-comp-display-modified>
      </td>
      <td>
        <sb-comp-display-created [data]="planning"></sb-comp-display-created>
      </td>
      <td class="sticky-col last-col">
        <ng-container [ngTemplateOutlet]="ActionButtons" [ngTemplateOutletContext]="{$implicit: planning}"></ng-container>
      </td>
    </tr>
  </ng-template>
  <!------------------------------

    Card Element

------------------------------->

  <ng-template #card let-planning>
    <sb-table-card [isHalfImgHeight]="true">
      <div table-card-header>
      </div>

      <div table-card-header-more>
        <ng-container [ngTemplateOutlet]="ActionButtons" [ngTemplateOutletContext]="{$implicit: planning}"></ng-container>
      </div>
      <div table-card-img>

      </div>
      <div table-card-body>
        <div
          class="sm:tw-grid sm:tw-grid-cols-4 tw-flex tw-flex-col tw-text-sbGray-800 *:sm:tw-col-span-2 *:tw-w-full *:tw-border-0 *:tw-border-b *:tw-border-solid *:tw-border-sbGray-200 *:tw-py-3.5 *:sm:tw-py-5">
          <sb-table-card-element
            class=""
            [orientation]="'left'" [headline]="'lang.planningsList.name' | translate">
            <sb-comp-name-wrapper>
              <sb-comp-link
                firstLine
                [title]="planning.name |truncate: 60"
                [tooltip]="'lang.globals.openDetails' | translate"
                [link]="util.RoutingID.planning" [pathParams]="[{id: 'planningID', value: planning?.id}]">
              </sb-comp-link>
              <span secondLine [innerHTML]="planning.description | truncate: 80"></span>
              <sb-tags thirdLine *ngPermissions="[permissionService.Permission.tag_list]" [tags]="planning.tags"
                       [dtoType]="tagService.TaggableDTO.Planning" [dtoId]="planning.id"></sb-tags>
            </sb-comp-name-wrapper>
          </sb-table-card-element>
          <sb-table-card-element class="" [headline]="'lang.planningsList.customer' | translate " [orientation]="'right'"
                                 [classes]="'tw-gap-2'">
            <sb-icon icon="company"></sb-icon>

            <span [innerHTML]="planning.forCustomer?.name ?? '-' | truncate : 23"></span>
          </sb-table-card-element>
          <sb-table-card-element class="!tw-border-0" [headline]="'lang.globals.modifiedAt' | translate" [orientation]="'left'">
            <sb-comp-display-modified [data]="planning" [hideTooltip]="true"></sb-comp-display-modified>
          </sb-table-card-element>
          <sb-table-card-element class="!tw-border-0" [headline]="'lang.globals.createdAt' | translate" [orientation]="'right'">
            <sb-comp-display-created [data]="planning" [reverse]="true"></sb-comp-display-created>
          </sb-table-card-element>
        </div>
      </div>
    </sb-table-card>
  </ng-template>
</sb-table-wrapper-new>

<ng-template #ActionButtons let-planning>
  <div class="tw-flex tw-gap-2.5">
    @if (isInModalContext) {
      <button
        sb-button-secondary
        type="button"
        color="blue"
        [icon]="'selection'"
        [iconButton]="true"
        sbTooltip="{{'lang.globals.selectFilter' | translate }}"
        (click)="selectPlanning(planning)">
      </button>

    } @else {
      <button
        sb-button-secondary
        type="button"
        color="yellow"
        [icon]="'planningSubmit'"
        [disabled]="planning.submissions.length <= 0"
        [iconButton]="true"
        [sbTooltip]="'nav.campaigns.partialPlannings' | translate"
        [sbRouterLink]="util.RoutingID.partialPlanning"
        [pathParams]="[{id: 'planningID', value: planning?.id}]"
      >
      </button>
      <sb-split-button
        [splitButtonItems]="planning.sbButtons ?? []"
        (selectedAction)="resolveSplitButtonAction(planning, $event)"
      ></sb-split-button>

    }
  </div>
</ng-template>
